import type { MailDraft } from "../components/mailDraft";

/**
 * お問い合わせ用のメールの下書き (`MailDraftComposer` に渡す)。本文に雛形を仕込み、メーラーで開くと
 * 項目が入力された状態で作成できるようにする。注文特定に必要な情報の記載漏れ (= やり取りの往復増加) を
 * 減らすのが目的。
 *
 * 過去の CS 返信では、送信元メールで注文を確認できなかったとき「注文番号・ご氏名 (フルネーム)・
 * 電話番号・メールアドレス」を尋ね直す定型が最頻出だった。それを最初から書いてもらう。
 *
 * 注文番号は空欄でよいとは書かない。注文時と違うアドレスから届くと送信元で注文を引けず、本文の
 * 注文番号が無ければ出荷の自動保留も効かない。ご注文前のお問い合わせは、記入不要の一文でお客様自身が
 * 該当しないと判断できる。
 */
export const CONTACT_SUPPORT_EMAIL = "c-support@survaq.com";

export const buildContactMail = (): MailDraft => {
  // 件名はお客様に書いてもらう (固定にすると、受信箱でどのメールも「お問い合わせ」になり用件が分からない)
  const subject = "";
  // 区切りは罫線 (─━═ の連続) でなく見出し (【ご注文情報】) で表す。罫線を使うと、返信メールが
  // MailDealer 経由で /cs のタイムラインに出るとき引用・署名トリム (trimReply) が罫線を境界と誤認し、
  // その下に書かれた注文特定情報が「引用・署名を表示」の裏に隠れてしまう。
  const body = [
    "【お問い合わせ内容】",
    "※ 必ずご記入ください",
    "",
    "",
    "【ご注文情報】",
    "※ ご注文に関するお問い合わせの場合はご記入ください（ご注文前のお問い合わせではご記入不要です）",
    "",
    "注文番号 (S または C ＋数字):",
    "ご氏名 (フルネーム):",
    "ご注文時のメールアドレス:",
    "お電話番号:",
    "ご購入商品名:",
  ].join("\n");
  return { to: CONTACT_SUPPORT_EMAIL, subject, body };
};
